"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { d: "M19.6 17.6C22.251 17.6 24.4001 15.451 24.4001 12.8C24.4001 10.149 22.251 8 19.6 8C16.949 8 14.7999 10.149 14.7999 12.8C14.7999 15.451 16.949 17.6 19.6 17.6Z", fill: colour }),
        react_1.default.createElement("path", { d: "M19.6 19.8C14.3201 19.8 10.0358 23.0622 10 28.3335C12.5477 30.6136 15.9119 32 19.6 32C23.2881 32 26.6523 30.6136 29.2 28.3335C29.1642 23.0622 24.8799 19.8 19.6 19.8Z", fill: colour })));
};
//# sourceMappingURL=Person.js.map